
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"opacity":".8","cx":"16","cy":"16","r":"16","fill":"#000"}}),_c('path',{attrs:{"d":"M23.942 11.958a.834.834 0 00-.834 0l-2.942 1.45a2.5 2.5 0 00-2.5-2.408h-7.5a2.5 2.5 0 00-2.5 2.5v5a2.5 2.5 0 002.5 2.5h7.5a2.5 2.5 0 002.5-2.408l2.967 1.483c.114.058.24.09.367.092a.833.833 0 00.833-.834v-6.666a.833.833 0 00-.391-.709zM18.5 18.5a.834.834 0 01-.834.833h-7.5a.834.834 0 01-.833-.833v-5a.833.833 0 01.833-.833h7.5a.834.834 0 01.834.833v5zm4.166-.517l-2.5-1.25v-1.466l2.5-1.25v3.966z","fill":"#fff"}})])
          )
        }
      }
    